@if (!isCollapsed) {
    <span class="!mb-0 py-1">
        @if (displayMembershipActive()) {
            <div class="chip-tertiary py-1 w-full text-center">
                Membership:
                <span class="text-success-600">Active</span>
            </div>
        } @else if (displayBecomeAMember() || displayRenewMembership()) {
            <button
                secondary
                thin
                mat-raised-button
                class="secondary px-5 py-1 w-full"
            >
                <a href="{{ externalLinks.enterpriseWireless.membership }}">
                    @if (displayBecomeAMember()) {
                        Become a Member
                    } @else {
                        Renew Membership
                    }
                </a>
            </button>
        }
    </span>
}
